module.exports = __webpack_public_path__ + "img/chatbot7.e46fee69.svg";